import { render, staticRenderFns } from "./TicketStatusSwitcher.vue?vue&type=template&id=5e0668b6&scoped=true"
import script from "./TicketStatusSwitcher.vue?vue&type=script&lang=js"
export * from "./TicketStatusSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TicketStatusSwitcher.vue?vue&type=style&index=0&id=5e0668b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0668b6",
  null
  
)

export default component.exports